import { render } from "./EmployeeBenefitIndex.vue?vue&type=template&id=569dd93c&scoped=true"
import script from "./EmployeeBenefitIndex.vue?vue&type=script&lang=js"
export * from "./EmployeeBenefitIndex.vue?vue&type=script&lang=js"

import "./EmployeeBenefitIndex.vue?vue&type=style&index=0&id=569dd93c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-569dd93c"]])

export default __exports__